import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { PLACEHOLDER } from '../../../../../../../../constants.js';
import { formatPowerValues } from '../../../../../utils.js';
import { PowerSelector } from '../PowerSelector/PowerSelector.js';
import { ReadOnlyElement } from '../ReadOnlyElement/ReadOnlyElement.js';
import { SelectElement } from '../SelectElement/SelectElement.js';

const SelectContainer = ({ attributes , activeFilters , id , handleAttributeChange , hasError , isActive , foundProduct ,  })=>{
    const selectors = [];
    // Defined order of the selector elements
    const sortSelectorOrder = [
        'color',
        'power',
        'baseCurve',
        'diameter',
        'axis',
        'addition',
        'cylinder', 
    ];
    const attributeKeys = sortSelectorOrder.filter((key)=>Object.keys(attributes).includes(key)
    );
    // Render selector elements
    attributeKeys.forEach((key)=>{
        const currentKey = key;
        const attributeError = Boolean(hasError && !activeFilters[currentKey]);
        const props = {
            attribute: currentKey,
            attributes,
            activeFilters,
            id,
            handleAttributeChange,
            hasError: attributeError,
            isActive,
            foundProduct
        };
        if (!attributes[currentKey]) {
            return;
        }
        if (currentKey === 'packageQuantity') {
            return;
        }
        if (currentKey === 'power') {
            const allPowerOptions = attributes.power ? formatPowerValues(attributes.power.values) : [];
            const onlyOneOptionAvailble = allPowerOptions.length <= 1;
            // value to set within PowerSelector via placeholder prop when selected
            // needed because of the isMobile render check below
            const initialValue = (activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.power) || PLACEHOLDER;
            const powerProps = swcHelpers.objectSpread({}, props, {
                options: allPowerOptions,
                initialValue
            });
            if (onlyOneOptionAvailble) {
                return selectors.push(/*#__PURE__*/ React.createElement(ReadOnlyElement, {
                    key: key,
                    attribute: powerProps.attribute,
                    value: initialValue,
                    id: id
                }));
            }
            return selectors.push(/*#__PURE__*/ React.createElement(PowerSelector, swcHelpers.extends({
                key: key
            }, powerProps)));
        } else {
            return selectors.push(/*#__PURE__*/ React.createElement(SelectElement, swcHelpers.extends({
                key: key
            }, props)));
        }
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, selectors);
};

export { SelectContainer };
//# sourceMappingURL=SelectContainer.js.map
